<template>
    <section id="tw-view-business-directories" class="tw-content col-12">
        <div class="bg-white">
            <div class="p-4">
                <div class="tw-table-header row">
                    <div class="tw-table-search-wrapper col-lg-4 text-end">
                        <input type="search" class="form-control" v-model="querySearch" placeholder="Search business directories" />
                        <span class="tw-table-header-search-icon"><i class="fas fa-search"></i></span>
                    </div>
                    <div class="col text-end mt-3 mt-lg-0 d-flex">
                        <button class="tw-default-bg-color text-white d-block d-lg-flex align-items-center ms-auto justify-content-center px-3 me-2" @click="openCategoriesModal">
                            <i class="fas fa-tags"></i>
                            <span class="ps-xl-3 d-inline-flex align-items-center flex-grow-1">Categories</span>
                        </button>
                        <button class="tw-default-bg-color text-white d-block d-lg-flex align-items-center justify-content-center px-3 me-auto me-lg-2" v-if="selected" @click.prevent="bulkDelete">
                            <i class="fa fa-trash"></i>
                            <span class="ps-xl-3 d-inline-flex align-items-center flex-grow-1">Delete {{ selected }} Items</span>
                        </button>
                        <button class="tw-red-bg-color text-white d-flex align-items-center me-auto me-lg-0" @click="openCreateModal()">
                            <span class="d-inline-flex justify-content-center align-items-center tw-light-red-bg-color me-3">
                                <i class="fas fa-plus"></i>
                            </span>
                            <span class="ps-xl-3 d-inline-flex align-items-center flex-grow-1 pe-5">Create Business Directory</span>
                        </button>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="tw-table table text-nowrap">
                        <thead>
                            <tr>
                                <th class="tw-table-checkbox-th"></th>
                                <th>Featured Image</th>
                                <th>
                                    <span class="cursor-pointer d-flex align-items-center" @click="setOrder('name')">
                                        <span class="me-3">Name</span>
                                        <span v-if="orderBy != 'name'" class="d-inline-flex align-items-center justify-content-center">
                                            <span class="tw-toggle-angle-up me-2"><span class="d-block"></span></span>
                                            <span class="tw-toggle-angle-down"><span class="d-block"></span></span>
                                        </span>
                                        <span v-if="orderBy == 'name' && order == 'asc'" class="d-inline-flex align-items-center justify-content-center">
                                            <span class="tw-toggle-angle-up"><span class="d-block"></span></span>
                                        </span>
                                        <span v-if="orderBy == 'name' && order == 'desc'" class="d-inline-flex align-items-center justify-content-center">
                                            <span class="tw-toggle-angle-down"><span class="d-block"></span></span>
                                        </span>
                                    </span>
                                </th>
                                <th>
                                    <span class="cursor-pointer d-flex align-items-center" @click="setOrder('slug')">
                                        <span class="me-3">Slug</span>
                                        <span v-if="orderBy != 'slug'" class="d-inline-flex align-items-center justify-content-center">
                                            <span class="tw-toggle-angle-up me-2"><span class="d-block"></span></span>
                                            <span class="tw-toggle-angle-down"><span class="d-block"></span></span>
                                        </span>
                                        <span v-if="orderBy == 'slug' && order == 'asc'" class="d-inline-flex align-items-center justify-content-center">
                                            <span class="tw-toggle-angle-up"><span class="d-block"></span></span>
                                        </span>
                                        <span v-if="orderBy == 'slug' && order == 'desc'" class="d-inline-flex align-items-center justify-content-center">
                                            <span class="tw-toggle-angle-down"><span class="d-block"></span></span>
                                        </span>
                                    </span>
                                </th>
                                <th>
                                    <span class="cursor-pointer d-flex align-items-center" @click="setOrder('date')">
                                        <span class="me-3">Date</span>
                                        <span v-if="orderBy != 'date'" class="d-inline-flex align-items-center justify-content-center">
                                            <span class="tw-toggle-angle-up me-2"><span class="d-block"></span></span>
                                            <span class="tw-toggle-angle-down"><span class="d-block"></span></span>
                                        </span>
                                        <span v-if="orderBy == 'date' && order == 'asc'" class="d-inline-flex align-items-center justify-content-center">
                                            <span class="tw-toggle-angle-up"><span class="d-block"></span></span>
                                        </span>
                                        <span v-if="orderBy == 'date' && order == 'desc'" class="d-inline-flex align-items-center justify-content-center">
                                            <span class="tw-toggle-angle-down"><span class="d-block"></span></span>
                                        </span>
                                    </span>
                                </th>
                                <th>Categories</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="position-relative">
                            <div v-if="!requestResolved" class="tw-table-loading-overlay pt-5 d-flex align-items-start justify-content-center position-absolute top-0 bottom-0 start-0 end-0 bg-white opacity-75">
                                <i class="fa fa-spinner fa-pulse fa-4x border-0"></i>
                            </div>
                            <tr v-for="(directory, index) in pagedDirectories" :key="directory.id">
                                <td class="tw-checkbox">
                                    <input :id="'directory' + directory.id" type="checkbox" @click="countSelected(index, $event)" value="1" :checked="directory.checked" />
                                    <label :for="'directory' + directory.id"></label>
                                </td>
                                <td>
                                    <img
                                        v-if="getFeaturedImageUrl(directory)"
                                        :src="getFeaturedImageUrl(directory)"
                                        alt="Featured image"
                                        width="80"
                                        height="56"
                                        style="object-fit: cover; border-radius: 4px"
                                    />
                                    <span v-else class="text-muted">-</span>
                                </td>
                                <td>
                                    <a class="tw-table-title-column" href="" @click.stop.prevent="openCreateModal(directory)" :title="directory.name">{{ sliceString(directory.name, 70) }}</a>
                                </td>
                                <td>{{ directory.slug }}</td>
                                <td>{{ moment(directory.created_at).format('ll') }}</td>
                                <td>{{ getCategoryNames(directory) }}</td>
                                <td class="text-end column-actions">
                                    <div class="d-flex justify-content-end">
                                        <a href="" @click.prevent="removeDirectory(directory)" class="d-flex align-items-center"><span class="fa-stack"><i class="tw-light-red-color fa fa-circle fa-stack-2x"></i><i class="fa fa-trash fa-stack-1x fa-inverse"></i></span></a>
                                        <a href="" @click.stop.prevent="openCreateModal(directory)" class="d-flex align-items-center"><span class="fa-stack"><i class="tw-light-red-color fa fa-circle fa-stack-2x"></i><i class="fas fa-pencil-alt fa-stack-1x fa-inverse"></i></span></a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-if="requestResolved && (!pagedDirectories || !pagedDirectories.length)">
                            <tr>
                                <td colspan="7" class="text-center">Nothing to show, no results found.</td>
                            </tr>
                        </tbody>
                        <tfoot v-if="filteredDirectories.length">
                            <tr>
                                <td colspan="4">
                                    Rows per page
                                    <select v-model="perPage" class="border">
                                        <option :value="5">5</option>
                                        <option :value="10">10</option>
                                        <option :value="20">20</option>
                                    </select>
                                </td>
                                <td colspan="4" class="tw-table-pagination text-end">
                                    <Pagination
                                        :totalItems="filteredDirectories.length"
                                        :currentPage="page"
                                        :perPage="perPage"
                                        @pageChanged="setPage"
                                        :goButton="false"
                                        styled="centered"
                                        borderActiveColor=""
                                        borderTextActiveColor="text-white"
                                    />
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>

        <CreateBusinessDirectoryModal
            ref="CreateBusinessDirectoryModal"
            :editing="editing"
            :editingDirectory="editingDirectory"
            @directorySaved="handleDirectorySaved"
            @modalHidden="handleModalHidden"
        />

        <div class="modal fade" ref="categoriesModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header tw-red-bg-color text-white">
                        <h5 class="modal-title">Business Directory Categories</h5>
                        <button type="button" class="btn-close btn-close-white" @click="categoriesModal.hide()"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row g-2 mb-3">
                            <div class="col-md-9">
                                <input type="text" class="form-control" placeholder="New category name" v-model="newCategoryName" />
                            </div>
                            <div class="col-md-3 d-grid">
                                <button class="btn tw-red-bg-color text-white" :disabled="!newCategoryName.trim() || categoryActionLoading" @click="createCategory">
                                    Create
                                </button>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <table class="table tw-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Slug</th>
                                        <th class="text-end">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="categoriesRequestLoading">
                                        <td colspan="3" class="text-center">Loading <i class="fa fa-spinner fa-spin"></i></td>
                                    </tr>
                                    <tr v-for="category in categories" :key="category.id">
                                        <td>
                                            <input
                                                v-if="editingCategoryId === category.id"
                                                type="text"
                                                class="form-control"
                                                v-model="editingCategoryName"
                                            />
                                            <span v-else>{{ category.name }}</span>
                                        </td>
                                        <td>{{ category.slug }}</td>
                                        <td class="text-end">
                                            <div class="d-flex justify-content-end gap-2">
                                                <button
                                                    v-if="editingCategoryId !== category.id"
                                                    class="btn btn-sm tw-default-bg-color text-white"
                                                    @click="startEditCategory(category)"
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    v-if="editingCategoryId === category.id"
                                                    class="btn btn-sm tw-red-bg-color text-white"
                                                    :disabled="!editingCategoryName.trim() || categoryActionLoading"
                                                    @click="saveCategoryEdit(category)"
                                                >
                                                    Save
                                                </button>
                                                <button
                                                    v-if="editingCategoryId === category.id"
                                                    class="btn btn-sm tw-dark-grey-bg-color text-white"
                                                    @click="cancelEditCategory"
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    class="btn btn-sm tw-light-red-bg-color text-white"
                                                    :disabled="categoryActionLoading"
                                                    @click="removeCategory(category)"
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="!categoriesRequestLoading && !categories.length">
                                        <td colspan="3" class="text-center">No categories found.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn tw-dark-grey-bg-color text-white" @click="categoriesModal.hide()">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { Modal } from "bootstrap";
import Pagination from "@/components/pagination/Pagination";
import CreateBusinessDirectoryModal from "@/components/modals/CreateBusinessDirectoryModal";
import helperMixin from "@/mixins/helperMixin";
import cms6Mixin from "@/mixins/cms6Mixin";
import siteMixin from "@/mixins/siteMixin";

export default {
    name: "BusinessDirectories",
    components: {
        Pagination,
        CreateBusinessDirectoryModal,
    },
    data: () => ({
        directories: [],
        categories: [],
        requestResolved: false,
        querySearch: "",
        page: 1,
        perPage: 10,
        order: "desc",
        orderBy: "date",
        selected: 0,
        editing: false,
        editingDirectory: null,
        categoriesModal: null,
        categoriesRequestLoading: false,
        categoryActionLoading: false,
        newCategoryName: "",
        editingCategoryId: null,
        editingCategoryName: "",
    }),
    computed: {
        filteredDirectories() {
            let result = [...this.directories];

            if (this.querySearch) {
                const q = this.querySearch.toLowerCase();
                result = result.filter((item) => {
                    return [item.name, item.slug].some((v) => (v || "").toString().toLowerCase().includes(q));
                });
            }

            const dir = this.order === "asc" ? 1 : -1;
            result.sort((a, b) => {
                let av = "";
                let bv = "";

                if (this.orderBy === "date") {
                    av = a.created_at || "";
                    bv = b.created_at || "";
                } else if (this.orderBy === "slug") {
                    av = (a.slug || "").toLowerCase();
                    bv = (b.slug || "").toLowerCase();
                } else {
                    av = (a.name || "").toLowerCase();
                    bv = (b.name || "").toLowerCase();
                }

                if (av < bv) return -1 * dir;
                if (av > bv) return 1 * dir;
                return 0;
            });

            return result;
        },
        pagedDirectories() {
            const start = (this.page - 1) * this.perPage;
            return this.filteredDirectories.slice(start, start + this.perPage);
        },
    },
    mounted() {
        this.categoriesModal = new Modal(this.$refs.categoriesModal);
        this.setCategories();
        this.setDirectories();
    },
    watch: {
        perPage() {
            this.page = 1;
        },
        querySearch() {
            this.page = 1;
        },
    },
    methods: {
        async setDirectories() {
            this.requestResolved = false;
            const res = await this.getBusinessDirectories();
            if (res && res.status === 200) {
                this.directories = (res.data || []).map((item) => ({ ...item, selected: false }));
            } else {
                this.directories = [];
            }
            this.requestResolved = true;
            this.selected = 0;
        },
        async setCategories(withLoader = false) {
            if (withLoader) {
                this.categoriesRequestLoading = true;
            }

            const res = await this.getBusinessDirectoryCategories();
            this.categories = res && res.status === 200 ? res.data || [] : [];

            if (withLoader) {
                this.categoriesRequestLoading = false;
            }
        },
        async openCategoriesModal() {
            this.newCategoryName = "";
            this.cancelEditCategory();
            await this.setCategories(true);
            this.categoriesModal.show();
        },
        async createCategory() {
            const name = this.newCategoryName.trim();
            if (!name) {
                return;
            }

            this.categoryActionLoading = true;
            try {
                await this.saveBusinessDirectoryCategory({ name: name });
                this.newCategoryName = "";
                await this.setCategories(true);
                this.$swal("Created!", "Category created successfully.", "success");
            } catch (error) {
                this.$swal("Error", "Category could not be created.", "error");
            }
            this.categoryActionLoading = false;
        },
        startEditCategory(category) {
            this.editingCategoryId = category.id;
            this.editingCategoryName = category.name || "";
        },
        cancelEditCategory() {
            this.editingCategoryId = null;
            this.editingCategoryName = "";
        },
        async saveCategoryEdit(category) {
            const name = this.editingCategoryName.trim();
            if (!name) {
                return;
            }

            this.categoryActionLoading = true;
            try {
                await this.updateBusinessDirectoryCategory({ id: category.id, name: name });
                await this.setCategories(true);
                this.cancelEditCategory();
                this.$swal("Updated!", "Category updated successfully.", "success");
            } catch (error) {
                this.$swal("Error", "Category could not be updated.", "error");
            }
            this.categoryActionLoading = false;
        },
        async removeCategory(category) {
            const result = await this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                icon: "warning",
                text: `Delete category "${category.name}"?`,
                confirmButtonText: "Yes, delete it!",
            });

            if (!result.isConfirmed) {
                return;
            }

            this.categoryActionLoading = true;
            try {
                await this.deleteBusinessDirectoryCategory(category.id);
                await this.setCategories(true);
                this.$swal("Deleted!", "Category deleted successfully.", "success");
            } catch (error) {
                this.$swal("Error", "Category could not be deleted.", "error");
            }
            this.categoryActionLoading = false;
        },
        getCategoryNames(directory) {
            const categoryIds = Array.isArray(directory?.categories)
                ? directory.categories.map((category) => (typeof category === "object" ? category?.id : category))
                : Array.isArray(directory?.category_ids)
                  ? directory.category_ids
                  : directory?.business_category_id
                    ? [directory.business_category_id]
                    : [];

            const names = categoryIds
                .map((categoryId) => this.categories.find((cat) => String(cat.id) === String(categoryId))?.name)
                .filter(Boolean);

            return names.length ? names.join(", ") : "-";
        },
        getFeaturedImageUrl(directory) {
            if (directory?.featured_media?.media_details?.sizes?.thumbnail?.source_url) {
                return directory.featured_media.media_details.sizes.thumbnail.source_url;
            }
            if (directory?.featured_media?.source_url) {
                return directory.featured_media.source_url;
            }
            if (directory?.featured_image?.media_details?.sizes?.thumbnail?.source_url) {
                return directory.featured_image.media_details.sizes.thumbnail.source_url;
            }
            if (directory?.featured_image?.source_url) {
                return directory.featured_image.source_url;
            }
            return null;
        },
        setPage(n) {
            this.page = n;
        },
        setOrder(orderBy) {
            if (this.orderBy !== orderBy) {
                this.order = "desc";
            } else {
                this.order = this.order === "desc" ? "asc" : "desc";
            }
            this.orderBy = orderBy;
        },
        countSelected(index, event) {
            const item = this.pagedDirectories[index];
            if (!item) {
                return;
            }
            item.selected = event.target.checked;
            this.selected = this.directories.filter((row) => row.selected).length;
        },
        openCreateModal(directory = null) {
            this.editing = !!directory;
            this.editingDirectory = directory ? { ...directory } : null;
            this.$refs.CreateBusinessDirectoryModal.showModal(true);
        },
        handleModalHidden() {
            this.editing = false;
            this.editingDirectory = null;
        },
        handleDirectorySaved(action) {
            this.$swal(`Business directory ${action}!`, `Business directory ${action} successfully!`, "success").then(() => {
                this.setDirectories();
            });
        },
        async removeDirectory(directory) {
            this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                icon: "warning",
                text: "Are you sure you want to delete this business directory?",
                confirmButtonText: "Yes, delete it!",
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    try {
                        return await this.deleteBusinessDirectory(directory.id);
                    } catch (error) {
                        this.$swal.showValidationMessage(`Request failed: ${error}`);
                    }
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal("Deleted!", "Business directory has been deleted!", "success").then(() => {
                        this.setDirectories();
                    });
                }
            });
        },
        async bulkDelete() {
            this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                icon: "warning",
                text: "Are you sure you want to delete all selected business directories?",
                confirmButtonText: "Yes, delete!",
            }).then(async (result) => {
                if (!result.isConfirmed) {
                    return;
                }

                const selectedItems = this.directories.filter((item) => item.selected);
                await Promise.all(selectedItems.map((item) => this.deleteBusinessDirectory(item.id)));
                this.$swal("Deleted!", "Selected business directories have been deleted!", "success");
                this.setDirectories();
            });
        },
    },
    mixins: [cms6Mixin, siteMixin, helperMixin],
};
</script>
